<template>
  <div class="search">
    <ul class="ml20 part03">
      <li class="flex nowrap start ">
        <dt class="nowrap title">课程类型：</dt>
        <dd class="flex flex1">
          <a @click="CourseType = 0" :class="{ on: CourseType == 0 }">全部</a>
          <a @click="CourseType = item.CourseType" v-for="(item, index) in typeList"
            :class="{ on: CourseType == item.CourseType }" :key="index">{{ item.CourseTypeName }}</a>
        </dd>
      </li>

      <li v-if="classifyList2.length > 0" class="flex nowrap start" style="padding-top: 0" ref="depart">
        <dt class="nowrap title width80"></dt>
        <dd class="flex flex1" :class="{ mr50: departMore > 1, 'height34px ohide': departMore == 2 }">
          <a @click="ClassifyID = item.ClassifyID" :class="{ on: ClassifyID == item.ClassifyID }"
            v-for="(item, index) in classifyList2" :key="index">{{ item.ClassifyName }}</a>
        </dd>
        <dd v-if="departMore > 1" class="absolute r t mt27 Conhover C888 pointer">
          <p v-if="departMore == 2" @click="departMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="departMore == 3" @click="departMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>
      <li class="flex nowrap start mb10" ref="profession">
        <dt class="nowrap title">课程分类：</dt>
        <dd class="flex flex1" :class="{
          mr50: professionMore > 1,
          'height34px ohide': professionMore == 2,
        }">
          <a :class="{ on: ClassifyID == 0 }" @click="changeClassify({ ClassifyID: 0 })">全部</a>
          <a @click="changeClassify(item, classifyList)" :class="{ on: PID == item.ClassifyID }"
            v-for="(item, index) in classifyList" :key="index">{{ item.ClassifyName }}</a>
        </dd>
        <dd v-if="professionMore > 1" class="absolute r t mt27 Conhover C888 pointer">
          <p v-if="professionMore == 2" @click="professionMore = 3">
            展开 <i class="el-icon-arrow-down"></i>
          </p>
          <p v-if="professionMore == 3" @click="professionMore = 2">
            收起 <i class="el-icon-arrow-up"></i>
          </p>
        </dd>
      </li>

    </ul>
    <div class="navbar flex">
      <div v-for="(item, index) in OrderByList" :key="index"
        :class="OrderBy == item.value ? 'navbar-item actives' : 'navbar-item'" @click="OrderBy = item.value">
        <img :src="OrderBy == item.value ? item.img1 : item.img" alt="" :class="item.class" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Course_GetTypes, Course_GetClassifys } from "@/api/course";
export default {
  name: "TrainTypeList",
  data() {
    return {
      PID: 0,
      typeList: [],
      CourseType: 0,
      departMore: 0, // 0隐藏  1单行显示 2多行收起 3多行展开
      classifyList: [],
      classifyList2: [],
      ClassifyID: 0,
      professionMore: 0,
      OrderBy: 3,
      OrderByList: [
        {
          name: "推荐",
          value: 3,
          img: require("@/assets/img/home/48.png"),
          img1: require("@/assets/img/home/49.png"),
          class: "recommend",
        },
        {
          name: "最新",
          value: 1,
          img: require("@/assets/img/home/50.png"),
          img1: require("@/assets/img/home/51.png"),
          class: "new",
        },
        {
          name: "最热",
          value: 2,
          img: require("@/assets/img/home/52.png"),
          img1: require("@/assets/img/home/53.png"),
          class: "hot",
        },
      ],
    };
  },

  watch: {
    OrderBy(v) {
      this.$router.replace({
        query: { ...this.$route.query, OrderBy: v },
      });
    },
    CourseType(v) {
      this.$router.replace({
        query: { ...this.$route.query, CourseType: v },
      });
    },
    ClassifyID(v) {
      this.$router.replace({
        query: { ...this.$route.query, ClassifyID: v },
      });
    },
    PID(v) {
      this.$router.replace({
        query: { ...this.$route.query, PID: v },
      });
    },
  },
  methods: {
    changeClassify(item, data) {
      this.PID = item.ClassifyID;
      this.ClassifyID = item.ClassifyID;
      const info = data.find((item) => item.ClassifyID == this.PID);
      if (info && info.Children && info.Children.length > 0) {
        this.classifyList2 = info.Children;
      } else {
        this.classifyList2 = [];
      }
    },
    getClassifyList2(item, data) {
      this.PID = item.ClassifyID;
      const info = data.find((item) => item.ClassifyID == this.PID);
      if (info && info.Children && info.Children.length > 0) {
        this.classifyList2 = info.Children;
      } else {
        this.classifyList2 = [];
      }
    },
    //将树形结构数据转换为平铺数据
    treeToArr(arr) {
      let result = [];
      let node = [];
      node = node.concat(arr);
      while (node.length) {
        let first = node.shift();
        if (first.Children) {
          node = node.concat(first.Children);
          delete first.Children;
        }
        result.push(first);
      }
      return result;
    },
  },
  async created() {
    let { ClassifyID, CourseType, PID, OrderBy } = this.$route.query;
    if (ClassifyID) {
      ClassifyID = Number(ClassifyID);
      this.ClassifyID = ClassifyID;
    } else {
      if (PID) {
        PID = Number(PID);
        this.PID = PID;
        this.ClassifyID = PID;
      }
    }
    if (OrderBy) {
      OrderBy = Number(OrderBy);
      this.OrderBy = OrderBy;
    }
    if (CourseType) {
      CourseType = Number(CourseType);
      this.CourseType = CourseType;
    }
    await Promise.all([Course_GetTypes(), Course_GetClassifys()]).then(
      (values) => {
        this.typeList = values[0].data;
        this.classifyList = values[1].data;

        this.getClassifyList2(
          {
            ClassifyID: this.$route.query.PID,
          },
          values[1].data
        );
        // this.classifyList = this.treeToArr(values[1].data);
      }
    );
    this.$nextTick(() => {
      if (this.$refs.depart) {
        this.departMore = this.$refs.depart.offsetHeight > 80 ? 2 : 1;
      }
      this.professionMore = this.$refs.profession.offsetHeight > 80 ? 2 : 1;
    }, 50);
  },
};
</script>

<style lang="scss" scoped>
.width80 {
  width: 80px;
}

.search {
  margin-top: 30px;
  width: 1760px;
  padding: 0 10px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16PX;
  color: #333333;

  .title {
    padding: 5px 0;
    color: #666666;
    margin-right: 10px;
  }

  .navbar {
    gap: 50px;
    padding: 20px 0;
    margin-left: 15px;
    border-top: 1px solid #e6e6e6;

    .actives {
      color: #1d79ff;
    }

    .navbar-item {
      cursor: pointer;

      img {
        margin-right: 5px;
      }

      .recommend {
        width: 16px;
        height: 15px;
        margin-top: -2px;
      }

      .new {
        width: 25pxx;
        height: 14px;
      }

      .hot {
        width: 22px;
        height: 17px;
      }
    }
  }
}
</style>
